import { Injectable } from '@angular/core';

@Injectable()
export class RouteAccessService {
    CanAccessRoute(route: string): boolean {
        return true;
    }
}
